import {
  PickupCorporateScheduleConfig,
  PickupScheduleTimeSlot
} from "@/domain/entities/PickupCorporateScheduleConfig";

export type ScheduleValidationResult = {
  valid: boolean;
  errors: string[];
};

const MAX_SLOTS = 3;
const MAX_SPECIAL_DATES = 3;

function hasDuplicateStart(times: PickupScheduleTimeSlot[]): boolean {
  return new Set(times.map((time) => time.start)).size !== times.length;
}

export function validatePickupCorporateScheduleConfig(
  config: PickupCorporateScheduleConfig
): ScheduleValidationResult {
  const errors: string[] = [];
  if (!config.estimateAdditionalKoli.trim()) {
    errors.push("ESTIMATE_TOTAL_KOLI_REQUIRED");
  }
  if (!config.estimateWeight.trim()) {
    errors.push("ESTIMATE_TOTAL_TONASE_REQUIRED");
  }
  const checkedDays = config.regularDays.filter((day) => day.checked);
  const hasRegularSchedule =
    config.regularEnabled && checkedDays.some((day) => day.times.length > 0);
  const hasSpecialSchedule =
    config.specialEnabled &&
    config.specialDates.some((date) => date.times.length > 0);

  if (!hasRegularSchedule && !hasSpecialSchedule) {
    errors.push("SCHEDULE_REQUIRED");
  }
  if (config.regularEnabled) {
    if (!checkedDays.length) errors.push("REGULAR_SLOT_REQUIRED");
    checkedDays.forEach((day) => {
      if (!day.times.length) errors.push("REGULAR_SLOT_REQUIRED");
      if (day.times.length > MAX_SLOTS) errors.push("REGULAR_MAX_SLOTS");
      if (hasDuplicateStart(day.times)) errors.push("REGULAR_DUPLICATE_TIME");
    });
  }
  if (config.specialEnabled) {
    if (!config.specialDates.length) errors.push("SPECIAL_DATE_REQUIRED");
    if (config.specialDates.length > MAX_SPECIAL_DATES) {
      errors.push("SPECIAL_MAX_DATES");
    }
    if (
      new Set(config.specialDates.map((date) => date.date)).size !==
      config.specialDates.length
    ) {
      errors.push("SPECIAL_DUPLICATE_DATE");
    }
    config.specialDates.forEach((date) => {
      if (!date.times.length) errors.push("SPECIAL_SLOT_REQUIRED");
      if (date.times.length > MAX_SLOTS) errors.push("SPECIAL_MAX_SLOTS");
      if (hasDuplicateStart(date.times)) errors.push("SPECIAL_DUPLICATE_TIME");
    });
  }
  return { valid: errors.length === 0, errors };
}
